import { MirageApplicationTypes } from "../mirage/core/IMirageApplications";
export class PPConstants {
    public static get AppName(): typeof MirageApplicationTypes.publicportal {
        return MirageApplicationTypes.publicportal;
    }
}
